(function(){
'use strict';
var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){
    if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}})},
    {threshold:.12,rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
}else{document.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');});}
var nav=document.getElementById('nav');
if(nav){addEventListener('scroll',function(){nav.classList.toggle('stuck',scrollY>40);},{passive:true});}
var sticky=document.getElementById('sticky');
if(sticky){addEventListener('scroll',function(){
  sticky.classList.toggle('on',scrollY>innerHeight*.9&&scrollY<document.body.scrollHeight-innerHeight*1.6);},{passive:true});}
var burger=document.querySelector('[data-burger]');
if(burger){burger.addEventListener('click',function(){
  var links=document.querySelector('.navlinks'); if(!links)return;
  var open=links.style.display==='flex';
  links.style.display=open?'':'flex';
  links.style.position='absolute';links.style.top='100%';links.style.left='0';links.style.right='0';
  links.style.flexDirection='column';links.style.gap='18px';links.style.padding='22px var(--gut)';
  links.style.background='rgba(15,11,9,.96)';links.style.backdropFilter='blur(16px)';
  burger.setAttribute('aria-expanded',String(!open));});}
if(!RM){
  var hm=document.querySelector('.hero-media'), hi=document.querySelector('.hero-inner');
  if(hm&&hi){addEventListener('scroll',function(){
    var y=Math.min(scrollY,innerHeight);
    hm.style.transform='translate3d(0,'+(y*.28)+'px,0)';
    hi.style.transform='translate3d(0,'+(y*.1)+'px,0)';
    hi.style.opacity=String(Math.max(0,1-y/(innerHeight*.72)));},{passive:true});}
}
if(!RM&&matchMedia('(hover:hover)').matches){
  document.querySelectorAll('.magnet').forEach(function(b){
    b.addEventListener('mouseenter',function(){b.style.transition='';});
    b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect();
      b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.18)+'px,'+((e.clientY-r.top-r.height/2)*.28)+'px)';});
    b.addEventListener('mouseleave',function(){b.style.transition='transform .5s cubic-bezier(.16,1,.3,1)';
      b.style.transform='';setTimeout(function(){b.style.transition='';},500);});});
}
var stage=document.getElementById('stage'), pill=document.getElementById('stagePill'), boxlist=document.getElementById('boxlist');
function showBox(i){
  if(!stage)return;
  stage.querySelectorAll('img').forEach(function(im){im.classList.toggle('on',+im.dataset.i===i);});
  document.querySelectorAll('#boxlist .item').forEach(function(el){el.classList.toggle('dim',+el.dataset.i!==i);});
  var cur=document.querySelector('#boxlist .item[data-i="'+i+'"]');
  if(pill&&cur&&cur.dataset.pill)pill.textContent=cur.dataset.pill;
}
if(boxlist){
  boxlist.addEventListener('click',function(e){var it=e.target.closest('.item');if(it)showBox(+it.dataset.i);});
  boxlist.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){var it=e.target.closest('.item');
    if(it){e.preventDefault();showBox(+it.dataset.i);}}});
  if(matchMedia('(min-width:1001px)').matches&&!RM&&'IntersectionObserver' in window){
    var bio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)showBox(+e.target.dataset.i);})},
      {threshold:.6,rootMargin:'-25% 0px -25% 0px'});
    document.querySelectorAll('#boxlist .item').forEach(function(el){bio.observe(el);});}
}
var moods=document.getElementById('moods'), res=document.getElementById('result');
if(moods&&res){
  moods.addEventListener('click',function(e){
    var b=e.target.closest('.mood'); if(!b)return;
    moods.querySelectorAll('.mood').forEach(function(x){x.classList.toggle('sel',x===b);});
    var d=b.dataset, avail=d.available==='true', qty=parseInt(d.qty||'0',10);
    var img=document.getElementById('rImg');
    if(d.img){img.src=d.img;img.alt=d.title+' candle by Mūd';}
    document.getElementById('rName').textContent=d.title;
    document.getElementById('rNotes').innerHTML=(d.notes||'').split('·').filter(Boolean)
      .map(function(n){return '<span class="note">'+n.trim()+'</span>';}).join('');
    document.getElementById('rWhy').textContent=d.why||'';
    document.getElementById('rPrice').textContent=d.price;
    var st=document.getElementById('rStock');
    st.className='stock'+(!avail?' out':(qty>0&&qty<=5?' low':''));
    st.textContent=!avail?'Sold out — join the waitlist':(qty>0&&qty<=5?('Only '+qty+' left in this batch'):'In stock');
    var add=document.getElementById('rAdd'), vid=document.getElementById('rVid'), view=document.getElementById('rView');
    if(vid)vid.value=d.vid; if(view)view.href=d.url;
    add.querySelector('span').textContent=avail?'Add to cart':'Sold out';
    add.disabled=!avail;
    res.classList.add('on');
    setTimeout(function(){res.scrollIntoView({behavior:RM?'auto':'smooth',block:'nearest'});},140);
  });
}
var thumbs=document.querySelector('.pdp-thumbs'), main=document.getElementById('pdpMain');
if(thumbs&&main){thumbs.addEventListener('click',function(e){
  var b=e.target.closest('button'); if(!b)return;
  main.src=b.dataset.full;
  thumbs.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);});});}
var lv=document.querySelectorAll('[data-lazyvideo]');
if(lv.length&&'IntersectionObserver' in window){
  var vio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;
    var v=e.target,s=v.querySelector('source[data-src]');
    if(s&&!s.src){s.src=s.dataset.src;v.load();v.play().catch(function(){});}
    vio.unobserve(v);})},{rootMargin:'300px'});
  lv.forEach(function(v){vio.observe(v);});
}
if('IntersectionObserver' in window&&!RM){
  var cio=new IntersectionObserver(function(es){es.forEach(function(e){
    e.target.classList.toggle('cinema-in',e.isIntersecting);})},{threshold:.05});
  document.querySelectorAll('[data-cinema]').forEach(function(s){cio.observe(s);});
}
document.querySelectorAll('[data-hscroll]').forEach(function(wrap){
  var track=wrap.querySelector('[data-hscroll-track]'); if(!track)return;
  var bar=wrap.querySelector('[data-hscroll-bar]');
  function prog(){if(!bar)return;var max=track.scrollWidth-track.clientWidth;
    bar.style.width=(max>0?(track.scrollLeft/max*100):0)+'%';}
  track.addEventListener('scroll',prog,{passive:true}); prog();
  wrap.querySelectorAll('[data-hscroll-prev],[data-hscroll-next]').forEach(function(b){
    b.addEventListener('click',function(){var c=track.querySelector('.hs-card'),step=c?c.offsetWidth+24:400;
      track.scrollBy({left:b.hasAttribute('data-hscroll-next')?step:-step,behavior:RM?'auto':'smooth'});});});
  if(!RM&&matchMedia('(min-width:1001px)').matches){
    wrap.addEventListener('wheel',function(e){
      if(Math.abs(e.deltaY)<Math.abs(e.deltaX))return;
      var max=track.scrollWidth-track.clientWidth;
      if((e.deltaY<0&&track.scrollLeft<=0)||(e.deltaY>0&&track.scrollLeft>=max-1))return;
      e.preventDefault(); track.scrollLeft+=e.deltaY;},{passive:false});}
});
})();

/* ---------------- cart drawer ---------------- */
(function(){
'use strict';
var drawer=document.getElementById('cartDrawer'); if(!drawer)return;
var overlay=document.querySelector('[data-cd-overlay]'), lastFocus=null;
function open(){lastFocus=document.activeElement;drawer.hidden=false;overlay.hidden=false;
  requestAnimationFrame(function(){drawer.classList.add('on');overlay.classList.add('on');});
  document.body.classList.add('cd-open');
  var c=drawer.querySelector('[data-cd-close]'); if(c)c.focus();}
function close(){drawer.classList.remove('on');overlay.classList.remove('on');
  document.body.classList.remove('cd-open');
  setTimeout(function(){drawer.hidden=true;overlay.hidden=true;if(lastFocus)lastFocus.focus();},520);}
window.MudCart={open:open,close:close};
async function refresh(){
  try{
    var r=await fetch('/?section_id=cart-drawer-refresh');
    if(r.ok){
      var doc=new DOMParser().parseFromString(await r.text(),'text/html');
      var body=doc.querySelector('[data-cd-body-src]'),foot=doc.querySelector('[data-cd-foot-src]'),cnt=doc.querySelector('[data-cd-count-src]');
      if(body)drawer.querySelector('[data-cd-body]').innerHTML=body.innerHTML;
      if(foot)drawer.querySelector('[data-cd-foot]').innerHTML=foot.innerHTML;
      if(cnt){var n=cnt.textContent.trim();
        var badge=document.getElementById('cc'); if(badge)badge.textContent=n;
        var lbl=drawer.querySelector('[data-cd-count]'); if(lbl)lbl.textContent='('+n+')';}
      return;}
  }catch(e){}
  try{var cj=await (await fetch('/cart.js')).json();
    var b=document.getElementById('cc'); if(b)b.textContent=cj.item_count;}catch(e){}
}
async function change(key,qty){
  await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:qty})});
  await refresh();
}
document.addEventListener('submit',async function(e){
  var f=e.target.closest('form[action*="/cart/add"]'); if(!f)return;
  e.preventDefault();
  var btn=f.querySelector('[type=submit]'),label=btn?btn.querySelector('span'):null,old=label?label.textContent:'';
  if(label)label.textContent='Adding…';
  try{
    var res=await fetch('/cart/add.js',{method:'POST',body:new FormData(f)});
    if(!res.ok)throw new Error('add failed');
    await refresh(); open();
  }catch(err){f.submit();return;}
  finally{if(label)label.textContent=old;}
});
drawer.addEventListener('click',function(e){
  var item=e.target.closest('.cd-item');
  if(item){var key=item.dataset.key,qEl=item.querySelector('[data-cd-q]'),q=parseInt(qEl.textContent,10);
    if(e.target.closest('[data-cd-plus]'))return change(key,q+1);
    if(e.target.closest('[data-cd-minus]'))return change(key,Math.max(0,q-1));
    if(e.target.closest('[data-cd-remove]'))return change(key,0);}
  if(e.target.closest('[data-cd-close]'))close();
});
overlay.addEventListener('click',close);
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!drawer.hidden)close();});
document.addEventListener('click',function(e){
  var t=e.target.closest('[data-cart-open]'); if(t){e.preventDefault();open();}});
drawer.addEventListener('keydown',function(e){
  if(e.key!=='Tab')return;
  var f=drawer.querySelectorAll('a[href],button:not([disabled]),input,select,textarea');
  if(!f.length)return;
  var first=f[0],last=f[f.length-1];
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
});
})();

/* ---------------- intro ---------------- */
(function(){
var intro=document.getElementById('mudIntro'); if(!intro)return;
var RM=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var seen=false; try{seen=sessionStorage.getItem('mud_intro')==='1';}catch(e){}
if(RM||seen||(window.Shopify&&window.Shopify.designMode)){intro.remove();return;}
intro.hidden=false;
document.body.classList.add('intro-lock');
requestAnimationFrame(function(){intro.classList.add('words-in');});
var armed=false;
setTimeout(function(){intro.classList.add('ready');armed=true;},2100);
function finish(){try{sessionStorage.setItem('mud_intro','1');}catch(e){}
  intro.classList.add('gone');document.body.classList.remove('intro-lock');
  setTimeout(function(){intro.remove();},640);}
var snd=document.getElementById('introMatch'),muteBtn=document.getElementById('introMute'),muted=false;
try{muted=localStorage.getItem('mud_muted')==='1';}catch(e){}
if(muteBtn){muteBtn.setAttribute('aria-pressed',String(muted));
 muteBtn.addEventListener('click',function(e){e.stopPropagation();muted=!muted;
  muteBtn.setAttribute('aria-pressed',String(muted));
  try{localStorage.setItem('mud_muted',muted?'1':'0');}catch(e){}
  if(muted&&snd){snd.pause();snd.currentTime=0;}});}
function strike(){if(!snd||muted)return;
 try{snd.volume=0.62;snd.currentTime=0;var pr=snd.play();if(pr&&pr.catch)pr.catch(function(){});}catch(e){}}
function enter(){strike();if(!armed||intro.classList.contains('flood'))return;
  intro.classList.add('flood');
  setTimeout(function(){intro.classList.add('falling');},1150);
  setTimeout(finish,2500);}
document.getElementById('introHit').addEventListener('click',enter);
document.getElementById('introSkip').addEventListener('click',function(e){e.stopPropagation();finish();});
document.addEventListener('keydown',function h(e){
  if(e.key==='Escape'){finish();document.removeEventListener('keydown',h);}
  else if((e.key==='Enter'||e.key===' ')&&!intro.classList.contains('flood')){e.preventDefault();enter();}});
setTimeout(function(){var b=document.getElementById('introHit');if(b)b.focus();},2200);
})();
